import { render, staticRenderFns } from "./ScenkonstPerformanceListing.vue?vue&type=template&id=94418106&scoped=true&"
import script from "./ScenkonstPerformanceListing.vue?vue&type=script&lang=ts&"
export * from "./ScenkonstPerformanceListing.vue?vue&type=script&lang=ts&"
import style0 from "./ScenkonstPerformanceListing.vue?vue&type=style&index=0&id=94418106&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94418106",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CardShow: require('/tmp/build_dc55b0b5/src/components/card/Show.vue').default,BlockWrapper: require('/tmp/build_dc55b0b5/src/components/block/BlockWrapper.vue').default,BlockHorizontalList: require('/tmp/build_dc55b0b5/src/components/block/HorizontalList.vue').default})
